import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const NormalBuildingIcon: LucideIcon = forwardRef(({ size = 20, color = 'black', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.54492 7.65004C7.54492 8.84517 8.51844 9.81668 9.71593 9.81668C10.9135 9.81668 11.8869 8.84513 11.8869 7.65004C11.8869 6.45491 10.9134 5.4834 9.71593 5.4834C8.51839 5.4834 7.54492 6.45495 7.54492 7.65004ZM10.5835 7.65004C10.5835 8.12972 10.1925 8.51591 9.71589 8.51591C9.23931 8.51591 8.84828 8.12566 8.84828 7.65004C8.84828 7.17442 9.23931 6.78417 9.71589 6.78417C10.1925 6.78417 10.5835 7.17442 10.5835 7.65004Z'
        fill={color}
      />
      <path
        d='M0.652138 20H19.3483C19.7067 20 20 19.7073 20 19.3496V7.05697C20 6.69923 19.7067 6.40656 19.3483 6.40656H15.1039L10.6517 2.13821V1.81301H11.0835C11.4419 1.81301 11.7352 1.52033 11.7352 1.1626C11.7352 0.804863 11.4419 0.512189 11.0835 0.512189H10.6354C10.5703 0.219516 10.3136 0 10 0C9.64154 0 9.34828 0.292674 9.34828 0.650409V2.13821L4.89614 6.40656H0.651721C0.293264 6.40656 0 6.69923 0 7.05697V19.3496C0 19.7073 0.293264 20 0.651721 20H0.652138ZM8.55016 18.6992V14.0121H10.8801V18.6992H8.55016ZM18.6966 18.6992H15.4949V7.70738H18.6966V18.6992ZM14.1915 18.6992H12.1833V13.3617C12.1833 13.0039 11.8901 12.7113 11.5316 12.7113H7.89825C7.53979 12.7113 7.24653 13.0039 7.24653 13.3617V18.6992H5.80868V7.33336L10.0001 3.31706L14.1916 7.33336L14.1915 18.6992ZM1.30365 7.70738H4.50532V18.6992H1.30365V7.70738Z'
        fill={color}
      />
      <path
        d='M2.90563 8.93066C2.54717 8.93066 2.25391 9.22334 2.25391 9.58107V11.4754C2.25391 11.8331 2.54717 12.1258 2.90563 12.1258C3.26408 12.1258 3.55735 11.8331 3.55735 11.4754V9.58107C3.55735 9.22334 3.26408 8.93066 2.90563 8.93066Z'
        fill={color}
      />
      <path
        d='M2.90563 13.6426C2.54717 13.6426 2.25391 13.9353 2.25391 14.293V16.1873C2.25391 16.545 2.54717 16.8377 2.90563 16.8377C3.26408 16.8377 3.55735 16.545 3.55735 16.1873V14.293C3.55735 13.9353 3.26408 13.6426 2.90563 13.6426Z'
        fill={color}
      />
      <path
        d='M17.0951 12.1258C17.4535 12.1258 17.7468 11.8331 17.7468 11.4754V9.58107C17.7468 9.22334 17.4535 8.93066 17.0951 8.93066C16.7366 8.93066 16.4434 9.22334 16.4434 9.58107V11.4754C16.4434 11.8331 16.7366 12.1258 17.0951 12.1258Z'
        fill={color}
      />
      <path
        d='M17.0951 16.8416C17.4535 16.8416 17.7468 16.549 17.7468 16.1912V14.2969C17.7468 13.9392 17.4535 13.6465 17.0951 13.6465C16.7366 13.6465 16.4434 13.9392 16.4434 14.2969V16.1912C16.4434 16.549 16.7366 16.8416 17.0951 16.8416Z'
        fill={color}
      />
    </svg>
  )
})

NormalBuildingIcon.displayName = 'NormalBuildingIcon'
